<template>

<div> 
  <!-- 公開ボタン後 -->
  <div class="card" style="border-radius: 5px; width:700px; display:inline-block; height:700px;" v-if="switchingView">
    <header class="card-header" style="height:75px;">
      <p class="card-header-title">
        公開します。この内容でよろしいでしょうか。
      </p>
    </header>

    <div class="card-content" style="height:600px; overflow-y: auto" >
      <p>タイトル：{{title}}</p>
      <div class="markdown disp-scroll" 
          style="margin-top: 20px; height: 500px;"  
          v-html="value">
      </div>

      <footer class="card-footer">
        <a class="card-footer-item" @click="switchingView=false">いいえ</a>
        <a class="card-footer-item" @click="postRelease();switchingView=false">はい</a>
      </footer>
    </div>
  </div>

  <div class="grid-container" v-if="!switchingView">
    <div class="accordion disp-scroll">
      <ul>
        <!-- 左側通行 -->
        <!-- 投稿ホーム -->  
        <button class="button outline-dark menu-card-major"
                @click="newPost()"
                v-bind:class="{'menu-card-hover' : nowActive == 0}"
                v-bind:disabled="nowContents!=value || nowTitle!=title">
          新規投稿
        </button>

        <button class="button menu-card-major"
                @click="draftAccordion = !draftAccordion">
          <div class="menu-title">下書き</div>
          <div v-if="!draftAccordion">▼</div>
          <div v-if="draftAccordion">▲</div>
        </button>

        <button v-for="(c, index) in draftTexts"
                :key = "`first-${index}`"
                class="button outline-dark menu-card-small"
                v-bind:class="{'menu-card-hover' : nowID == c.contents_id}"
                v-if="draftAccordion" @click="draftGet(index)"
                v-bind:disabled="nowContents!=value || nowTitle!=title">
                    {{c.title}}
                <br>
                    {{getTimes(c.updated_at)}} 
        </button>
        
        <button class="button menu-card-major"
                @click="releaseAccordion = !releaseAccordion">
          <div class="menu-title">公開済</div>
          <div v-if="!releaseAccordion">▼</div>
          <div v-if="releaseAccordion">▲</div>
        </button>

        <button v-for="(c, index) in releaseTexts"
                :key = "`second-${index}`"
                class="button outline-dark menu-card-small"
                v-bind:class="{'menu-card-hover' : nowID == c.contents_id}"
                v-if="releaseAccordion"
                @click="releaseGet(index)"
                v-bind:disabled="nowContents!=value || nowTitle!=title">
                    {{c.title}}
                   <br>
                    {{getTimes(c.updated_at)}} 
        </button>
      </ul>
    </div>

    <div class="inputTitle">  
      <b-field style="font-size:13px;" horizontal label="　　　　タイトル：">
            <b-input v-model="title"
              size="is-small"
              placeholder="10文字以下で入力してください"
              maxlength="10"
              ></b-input>
        </b-field>
    </div>

    <div class="markdown disp-scroll">
      <quill-editor 
        v-model="value" 
        style="height:95%; color:#222;" 
        ref="quillEditor"
        :options="options"
        v-if="isModalConfirmation==false && isModalDelete==false"
        >
      </quill-editor>
    </div>

    <div class="select_bt">
      <!-- 新規投稿 -->
      <button class="button is-warning change-button" @click="postChange()" v-if="nowActive == 0" v-bind:disabled="this.value=='' && this.title==''">変更を破棄する</button>
      <button class="button new_savedraft-button" @click="postDraft()" v-if="nowActive == 0" v-bind:disabled="this.value=='' || this.title==''">下書きを保存</button>
      <button class="button is-primary release-button"  @click="switchingView=true"  v-if="nowActive == 0" v-bind:disabled="this.value==''  || this.title==''">公開</button>

      <!-- 下書き -->
      <button class="button is-danger delete-button" @click="deleteRelease()" v-if="nowActive == 2">削除</button>
      <button class="button is-warning change-button" @click="postChange()" v-if="nowActive == 2" v-bind:disabled="nowContents==this.value && nowTitle==title">変更を破棄する</button>
      <button class="button draft_savedraft-button"  @click="updateRelease()" v-if="nowActive == 2" v-bind:disabled="(nowContents==this.value && nowTitle==title) || this.value=='' || this.title==''">下書きを保存</button>
      <button class="button is-primary release-button" @click="updateDraftToRelease()" v-if="nowActive == 2" v-bind:disabled="this.value=='' || this.title==''">公開</button>

      <!-- 公開済 -->
      <button class="button is-danger delete-button" @click="deleteRelease()" v-if="nowActive == 1">削除</button>
      <button class="button is-warning change-button" @click="postChange()" v-if="nowActive == 1" v-bind:disabled="nowContents==this.value && nowTitle==title">変更を破棄する</button>
      <button class="button release_savedraft-button" @click="releaseToDraft()" v-if="nowActive == 1" v-bind:disabled="this.value=='' || this.title=='' ">公開済から下書きに戻す</button>
      <button class="button is-primary release-button" @click="updateReleaseToRelease()" v-if="nowActive == 1" v-bind:disabled="this.value=='' || this.title==''">更新</button>
    </div>

    <b-modal :active.sync="isModalDelete" @close="isModalDelete=false"> 
      <ModalDeleteMarkdown v-bind:isConfirmation="isConfirmation" v-bind:nowID="nowID" @deleteMessage="deleteMethod"/>
    </b-modal>

    <b-modal :active.sync="isModalConfirmation" @close="isModalConfirmation=false" no-close-on-backdrop no-close-on-esc>
      <ModalConfirmation v-bind:isConfirmation="isConfirmation" @contentsMessage="contentsMethod"/>
    </b-modal>
  </div>
</div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";
import ModalDeleteMarkdown from './ModalDeleteMarkdown'
import ModalConfirmation from './ModalConfirmation'

Vue.use(mavonEditor);

export default {
  name: "app",
  components:{
    ModalDeleteMarkdown,
    ModalConfirmation,
    // to define as a component ( to be able to recognize as a prts パーツ化する。　このファイルで使えるように）
  },
  data() {
    return {
      title:"",
      nowTitle:"",
      isModalConfirmation:false,
      isModalDelete:false,
      noButton:false,
      switchingView:false,
      draftAccordion:true,
      releaseAccordion:true,
      isConfirmation: "",
      nowID:"",
      nowContents:"",
      beforeID:"",
      value: "",
      active: 0,
      nowActive:0,

      // #########追加
      options: {
        theme: 'snow',
        modules: {
          toolbar: ['bold', 'italic', 'underline', 'strike', 'link', 'image', { 'size': ['small', false, 'large', 'huge'] }, { 'color': [] }, { 'background': [] }]
        },
        placeholder: 'ここに内容を入力...',
      },

    }; 
  },
  computed:{
      ...mapState("tools",["releaseContents", "draftTexts", "releaseTexts"]),
   },
  methods: {
    // 新規投稿
    newPost(){
      this.value = ""
      this.nowActive = 0
      this.nowID = ""
      this.nowContents = ""
      this.title = ""
      this.nowTitle=""
    },
    
    // 下書き取得
    draftGet(index){
      this.value = this.draftTexts[index].contents
      this.nowActive = 2
      this.nowID = this.draftTexts[index].contents_id
      this.nowContents = this.draftTexts[index].contents
      this.title = this.draftTexts[index].title
      this.nowTitle = this.draftTexts[index].title
    },
    // 公開済取得
    releaseGet(index){
      this.value = this.releaseTexts[index].contents
      this.nowActive = 1
      this.nowID = this.releaseTexts[index].contents_id
      this.nowContents = this.releaseTexts[index].contents
      this.title = this.releaseTexts[index].title
      this.nowTitle = this.releaseTexts[index].title
    },
    
// #########################################################
    // 公開
    postRelease(){
      this.active = 1
      this.beforeID = this.nowID
      this.$store.dispatch("tools/postText", { contents: this.value, active: this.active, title: this.title});
      this.value = ''
      this.title = ''
    },

    // 下書き保存
    postDraft() {
      console.debug('*** Start *** clickpostText')
      this.active = 2
      this.$store.dispatch("tools/postText", { contents: this.value, active: this.active,  title: this.title});
      this.isConfirmation = "下書きに保存"
      this.isModalConfirmation = true
      console.debug('*** End *** clickpostText')
    },
    
    // 下書きから下書き
    updateDraftToRelease(){
      console.debug('*** Start *** deleteChatBot')
      this.$store.dispatch('tools/changeText',
        {
          'contents_id': this.nowID,
          'contents': this.value,
          'active': 1,
          'title': this.title
        }
      )
      this.isConfirmation = "公開"
      this.isModalConfirmation = true
    },

    // 下書きから下書き
    updateReleaseToRelease(){
      console.debug('*** Start *** deleteChatBot')
      this.$store.dispatch('tools/changeText',
        {
          'contents_id': this.nowID,
          'contents': this.value,
          'active': 1,
          'title': this.title
        }
      )
      this.isConfirmation = "公開"
      this.isModalConfirmation = true
    },

    // 下書きから下書き
    updateRelease(){
      console.debug('*** Start *** deleteChatBot')
      this.$store.dispatch('tools/changeText',
        {
          'contents_id': this.nowID,
          'contents': this.value,
          'active': 2,
          'title': this.title
        }
      )
      this.isConfirmation = "下書きに保存"
      this.isModalConfirmation = true
    },

    // 公開済から下書き
    releaseToDraft(nowID, value){
      console.debug('*** Start *** updateText')
      console.debug('ID: ' + JSON.stringify(this.nowID))
      console.debug('value: ' + JSON.stringify(this.value))
      this.isConfirmation = "下書きに保存"
      this.isModalConfirmation = true
      this.$store.dispatch('tools/changeText',
        {
          'contents_id': this.nowID,
          'contents': this.value,
          'active': 2,
          'title': this.title
        }
      )
      console.debug('*** End *** updateText')
    },

    // 変更破棄
    postChange(){
      this.value = this.nowContents
      this.title = this.nowTitle
    },
    // 削除
    deleteRelease(){
      this.isModalDelete=true
    },

    // 左メニュー表示
    // 左メニュー日時
    getTimes(time){
      var ja_time = new Date(time.replace(/-/g, '/').substring(0, 17) + time.substring(25, 29)).toString()
      var new_time = ja_time.replace(/Jan/g, '01').replace(/Feb/g, '02').replace(/Mar/g, '03').replace(/Apr/g, '04').replace(/May/g, '05').replace(/Jun/g, '06').replace(/Jul/g, '07').replace(/Aug/g, '08').replace(/Sep/g, '09').replace(/Oct/g, '10').replace(/Nov/g, '11').replace(/Dec/g, '12')
      var get_year = new_time.substring(10,14)
      var get_month = new_time.substring(4,6)
      var get_day = new_time.substring(7,9)
      var get_time = new_time.substring(15,20)
      var dis_time = get_year + '-' + get_month + '-' + get_day + ' ' + get_time
      return dis_time
    },

    // 更新が最新のものを上に
    getSort(time){
      var ja_time = new Date(time.replace(/-/g, '/').substring(0, 17) + time.substring(25, 29)).toString()
      var new_time = ja_time.replace(/Jan/g, '01').replace(/Feb/g, '02').replace(/Mar/g, '03').replace(/Apr/g, '04').replace(/May/g, '05').replace(/Jun/g, '06').replace(/Jul/g, '07').replace(/Aug/g, '08').replace(/Sep/g, '09').replace(/Oct/g, '10').replace(/Nov/g, '11').replace(/Dec/g, '12')
      var get_year = new_time.substring(10,14)
      var get_month = new_time.substring(4,6)
      var get_day = new_time.substring(7,9)
      var get_hour = new_time.substring(15,17)
      var get_minute = new_time.substring(18,20)
      var dis_time = get_year + get_month + get_day + get_hour + get_minute
      return Number(dis_time)
    },

    // 削除後
    deleteMethod(id) {
      console.debug('*** Start *** deleteMethod')
      this.nowActive = id
      this.nowID = ""
      this.value = ""
      this.nowContents = ""
      this.title=""
      this.nowTitle = ""
      console.debug('*** End *** deleteMethod')
    },

    // 公開、下書き処理後
    contentsMethod(id){
      console.debug('*** Start *** deleteMethod')
      this.nowActive = id
      this.noButton = false
      setTimeout(() => {
      var number = 0
      for (var i in this.releaseContents)      
        if (number <  this.getSort(this.releaseContents[i].updated_at)){
          var n = i
          number = this.getSort(this.releaseContents[i].updated_at)
        }
          this.value = this.releaseContents[n].contents
          this.nowContents = this.releaseContents[n].contents
          this.nowID = this.releaseContents[n].contents_id
          this.title = this.releaseContents[n].title
          this.nowTitle = this.releaseContents[n].title
      }, 500); 
      console.debug('*** End *** deleteMethod')
    },
  }  
}

</script>

<style scoped>

.grid-container {
  display: grid;
  grid-template-columns: 200px 750px;
  grid-template-rows: 60px 550px 50px;
  grid-template-areas: "accordion inputTitle" "accordion markdown" "accordion select_bt";
}

.accordion {
  grid-area: accordion;
  background: white;
}

.accordion::-webkit-scrollbar-thumb {
  background: #E53787;
}
.accordion::-webkit-scrollbar-track-piece:start {
  border-radius: 10px;
  background: silver;
}
.accordion::-webkit-scrollbar-track-piece:end {
  border-radius: 10px;
  background: silver;
}

.inputTitle {
  padding:10px;
  grid-area: inputTitle;
  background-color: white;
  color:black;
}

.markdown {
  grid-area: markdown;
  background-color: white;
}

.select_bt {
  height:50px;
  margin-top:550px;
  grid-area: markdown;
  background: white;
}

.delete-button{
  margin-top:8px;
}

.change-button{
  margin-top:8px;
}

.new_savedraft-button{
  margin-top:8px;
  margin-right:10px;
}

.draft_savedraft-button{
  margin-top:8px;
  margin-right:10px;
}

.release_savedraft-button{
  margin-top:8px;
  margin-right:10px;
}

.release-button{
  margin-top:8px;
}

.menu-title{
  float:left;
  padding-left:40px;
  padding-right:30px;
}

.menu-card-major {
  padding-top:5px;
  color:black;
  background-color: white;
  margin-top:5px;
  margin-bottom:5px;
  margin-left:0px;
  height: 50px;
  width: 160px;
  border: solid thin #222;
  /* border-top:none;
  border-left:none; */
  position:relative;
}

.menu-card-major:hover {
  background-color: rgb(240, 167, 184);
  color: white;
  /* cursor:pointer; */
}

.menu-card-major a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}

.menu-card-major a:link {
  color: black;
}
.menu-card-major a:visited {
  color: black;
}
.menu-card-major a:hover {
  color: black;
}
.menu-card-major a:active {
  color: black;
}

.menu-card-small {
  font-size:14px;
  text-align: left;
  /* padding-left:10px; */
  color:black;
  background-color: white;
  margin-top:5px;
  margin-bottom:5px;
  /* margin-left:0px; */
  height: 70px;
  width: 160px;
  border: solid #000000;
  /* border-top:none;
  border-left:none; */
  position:relative;
}

.menu-card-small:hover {
  background-color: rgb(240, 167, 184);
  color: white;
  /* cursor:pointer; */
}

.menu-card-small a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}

.menu-card-small a:link {
  color: black;
}
.menu-card-small a:visited {
  color: black;
}
.menu-card-small a:hover {
  color: black;
}
.menu-card-small a:active {
  color: black;
}

.menu-card-hover{
  background-color: #E53860;
  color: white;
  position:relative;
}

.menu-card-hover:hover{
  background-color: #E53860;
  color: white;
  cursor:auto;
}

.menu-card-hover a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}

.menu-card-hover a:link {
  color: white;
}
.menu-card-hover a:visited {
  color: white;
}
.menu-card-hover a:hover {
  color: white;
}
.menu-card-hover a:active {
  color: white;
}

ul {
  list-style: none;
}

.card-header-title{
  padding-left:20%;
  font-size:20px;
}
</style>


// WEBPACK FOOTER //
// src/views/Release/ReleaseMarkdown.vue